import { createTokenHeader } from '../utils/functions/headers';
import {
  // TGetAllProspectSellerParams,
  TProspectSeller,
  TProspectSellerAllDetails,
  TProspectSellerDetails,
  TProspectSellercategories,
  TUploadDocument,
  TUploadDocumentResponse,
  TVerifyProspect,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const prospectSellerService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getAllProspectSellerList: builder.query({
        query: (params) => ({
          url: 'seller/list/',
          method: 'GET',
          params: params,
        }),
        transformResponse: (
          data: TProspectSeller[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
      getSellerDetails: builder.query<
        TProspectSellerAllDetails,
        number | string
      >({
        query: (id) => ({
          method: 'GET',
          url: `seller/${id}`,
        }),
      }),
      getCategories: builder.query<
        Array<TProspectSellercategories>,
        void
      >({
        query: () => ({
          method: 'GET',
          url: `product-categories`,
        }),
      }),
      uploadDocumentProspect: builder.mutation<
        TUploadDocumentResponse,
        TUploadDocument
      >({
        query: ({ data, type }) => {
          return {
            url: `enterprise/document/upload/${type}`,
            method: 'POST',
            data,
            headers: createTokenHeader(),
          };
        },
      }),

      verifyProspect: builder.mutation<
        boolean,
        TVerifyProspect
      >({
        query: (data) => {
          return {
            url: 'enterprise/verify',
            method: 'POST',
            data,
          };
        },
      }),

      activateSeller: builder.mutation<
        boolean,
        TProspectSellerDetails
      >({
        query: (data) => {
          return {
            url: 'seller/activate',
            method: 'POST',
            data,
          };
        },
      }),
    }),
  });

export const {
  useGetAllProspectSellerListQuery,
  useGetSellerDetailsQuery,
  useGetCategoriesQuery,
  useUploadDocumentProspectMutation,
  useVerifyProspectMutation,
  useActivateSellerMutation,
} = prospectSellerService;
